import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

// import NewPatient from '../views/patient/new-patient.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // {
  //   path: '/about',
  //   name: 'About',

  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: () => import('../views/security/forgot-password.vue')
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => import('../views/security/reset-password.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/security/list-user.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/security/login.vue')
  },
  {
    path: '/patient',
    name: 'patient',
    component: () => import('../views/patient/list-patient.vue')
  },
  {
    path: '/assessment',
    name: 'assessment',
    component: () => import('../views/assessment/list-assessment.vue')
  },
  {
    path: '/assessmentType',
    name: 'assessmentType',
    component: () => import('../views/assessment/list-assessment-type.vue')
  },
  {
    path: '/assessmentReport',
    name: 'assessmentReport',
    component: () => import('../views/assessment/report-assessment.vue'),
    // props:route => ({query:route.query.patientId})
    props: true
  },
  {
    path: '/changeMyPassword',
    name: 'changeMyPassword',
    component: () => import('../views/security/changeMyPassword.vue')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/security/logout.vue')
  },
  {
    path: '/audit',
    name: 'audit',
    component: () => import('../views/audit/list-audit.vue')
  },
  {
    path: '/eula',
    name: 'eula',
    component: () => import('../views/security/eula.vue')
  }
]

const router = new VueRouter({
  routes
})



export default router
